import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { CoreService } from "../../shared/services/core.service";
import { LoginService } from "../../shared/services/login.service";
import { Address, Merchant } from "src/app/shared/models/merchant";
import { LoginPagemodel } from "src/app/shared/pageModels/loginPage";
import { OrderAppType } from "src/app/shared/helpers/helper.common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";
import { NgStyle, AsyncPipe } from "@angular/common";
import { Subscription, timeout } from "rxjs";
import { User } from "../../shared/models/Userverify.model";
import { GuestloginComponent } from "../login/Guest_login/guestlogin.component";
import { basketService } from "../../shared/services/basket.service";
import { selectLocationComponent } from "src/app/dashboard/Table_Fulfillment/select-location.component";
import { PinAddressMapComponent } from "src/app/shared/commonComponent/PinAddress_Map/PinAddressMap.component";
import { MessagePopupComponent } from "src/app/shared/commonComponent/MessagePopup/MessagePopup.component";
import { UserService } from "src/app/shared/services/user.service";
import { Fulfillmentmodel } from "src/app/shared/pageModels/CommonPay";
@Component({
  selector: "app-popup-login",
  templateUrl: "./popup-login.component.html",
  standalone: true,
  imports: [
    NgStyle,
    FormsModule,
    RouterLink,
    GuestloginComponent,
    AsyncPipe,
    selectLocationComponent,
    PinAddressMapComponent,
  ],
})

// Import required modules and classes
export class PopupLoginComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit
{
  // ViewChild to reference the errorinfo element in the template
  @ViewChild("errorinfo", { static: true }) private errorinfo;
  @ViewChild("basketinfo", { static: true }) private basketinfo;
  @ViewChild("locationinfo", { static: true }) private locationinfo;

  // Observable for Merchant data
  Merchant$ = this.coreService.Merchant$;
  // Variable to store currentMerchant data
  currentMerchant: Merchant;
  // Instance of LoginPagemodel to manage page model data
  pageModel: LoginPagemodel;
  // Boolean flag to indicate if GuestLogin is true or false
  GuestLogin: Boolean = false;
  // Subscription to manage the observable subscription
  subscription: Subscription;

  temp_user: User;
  selectedLocationData;
  selectedLocation: Address;
  selectedTable = {};
  isFromLogin = false;

  //Location selection component
  fulfillment;
  loginPopup;

  isServe;

  @Input() ShowLogin: any;

  @Output() CloseLoginPopup = new EventEmitter<boolean>();

  @ViewChild(PinAddressMapComponent) OpenAddress: PinAddressMapComponent;
  @ViewChild(MessagePopupComponent) OpenMessage: MessagePopupComponent; // Reference to the MessagePopupComponent

  // Constructor to initialize class dependencies and pageModel
  constructor(
    private router: Router,
    private coreService: CoreService,
    private authenticationService: LoginService,
    private modalService: NgbModal,
    private basketService: basketService,
    private userService: UserService,
    private ngZone: NgZone,
    private cds: ChangeDetectorRef,
  ) {
    this.pageModel = new LoginPagemodel();
  }

  // Lifecycle hook: ngOnDestroy
  ngOnDestroy(): void {
    // Unsubscribe from the subscription to avoid memory leaks
    this.subscription.unsubscribe();
  }

  // Lifecycle hook: ngOnInit
  ngOnInit() {
    this.fulfillment = document.getElementById("commonFulfillmentModal1");

    this.subscription = this.Merchant$.subscribe((data) => {
      // Check if data is available and it's not a multi_outlet
      if (data) {
        // Update currentMerchant with data from the server
        this.currentMerchant = data;
      }
    });
  }

  // Lifecycle hook: ngAfterViewInit
  ngAfterViewInit() {
    // Subscribe to the Merchant$ observable to get data from the server
    this.subscription = this.Merchant$.subscribe((data) => {
      // Check if data is available and it's not a multi_outlet
      if (data) {
        // Update currentMerchant with data from the server
        this.currentMerchant = data;

        if (!data.multi_outlet) {
          // Show the login information popup to users who come to the login page for the first time
          if (!sessionStorage.getItem("isfirsttimelogin")) {
            // this.modalService.open(this.errorinfo, { scrollable: true });
            // Hide the login information popup for the next time
            sessionStorage.setItem("isfirsttimelogin", "1");
          }
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  // Method to attempt login using the provided user credentials
  attemplogin(user) {
    // Check if the user form is valid
    if (!user.valid) {
      return;
    }

    // Call the authentication service to perform the login
    this.authenticationService
      .login(
        user.form.value.txtusername,
        user.form.value.txtpassword,
        OrderAppType.webapp,
      )
      .subscribe(
        (resp) => {
          // Handle the response data after login
          var data = resp.data;
          if (data.success) {
            // Store user details in local storage and emit data using UserSub subject from coreService
            localStorage.setItem("currentUser", JSON.stringify(data));
            this.coreService.UserSub.next(data);
            localStorage.setItem("session_count", "1");
            const now = Date.now();
            localStorage.setItem("last_session_time", now.toString());
            sessionStorage.setItem("session_started", "true");
            // Navigate to the dashboard page after successful login
            // this.router.navigate(["/dashboard"]);
            this.CloseLoginPopup.emit();
            // this.modalService.dismissAll();
            // this.ShowLogin = false;

            if (!this.currentMerchant.multi_outlet) {
              setTimeout(() => {
                if (
                  this.currentMerchant.webapp_settings
                    ?.enable_location_selection_screen
                ) {
                  this.checkSelectedLocation();
                }
              }, 500);

              // uncomment for basket retrieve feature
              setTimeout(() => {
                this.basketService.CheckForStoredBasket().subscribe((resp) => {
                  if (resp.data) {
                    this.modalService.open(this.basketinfo, {
                      centered: true,
                      scrollable: true,
                    });
                  }
                });
              }, 500);
            }
          } else {
            // Alert the user if there's an error during login
            alert(data?.error);
          }
        },
        (error) => {
          // Handle errors during login
          if (error.status === 422) {
            alert(JSON.stringify(error?.error?.errors));
          } else {
            alert(JSON.stringify(error?.error?.errors));
          }
        },
      );
  }

  closeLogin() {
    this.CloseLoginPopup.emit();
  }

  checkSelectedLocation() {
    this.userService.GetSelectedLocation().subscribe((resp) => {
      if (resp.data) {
        this.fulfillment.style.display = "block";

        this.ngZone.run(() => {
          this.selectedLocationData = resp.data;
          this.selectedLocation = { ...this.selectedLocationData.address };
          this.selectedTable = { ...this.selectedLocationData.table };

          var fulfillment = new Fulfillmentmodel();
          fulfillment.selectedTable = this.selectedTable;
          fulfillment.selectedaddress = this.selectedLocation;

          localStorage.setItem(
            "selected_location",
            JSON.stringify(fulfillment),
          );

          this.isFromLogin = true;

          this.cds.detectChanges();
        });
      }
    });
  }

  // retrieveLocation() {

  //   this.selectedLocationData
  //   this.basketService.GetStoredBasket().subscribe((resp) => {
  //     if (resp.success) {
  //       this.coreService.addItemToBasket(resp.data.items);
  //     }
  //   });
  // }

  retrieveBasket() {
    this.basketService.GetStoredBasket().subscribe((resp) => {
      if (resp.success) {
        this.coreService.addItemToBasket(resp.data.items);
      }
    });
  }

  // Method to set GuestLogin value based on the user input
  Guestlogin(value: boolean) {
    this.GuestLogin = value;
  }

  // Method to open the login information popup
  LoginInfo() {
    this.pageModel.isInfoPopup = true;
    this.modalService.open(this.errorinfo, {
      centered: true,
      scrollable: true,
    });
  }

  SkipLogin() {
    this.temp_user = {
      id: "0",
      firstName: "temp_user",
      lastName: "",
      userName: "",
      phoneNumber: "",
      password: "",
      email: "",
      token: "temp_token",
      dialcode: "",
      account_verified: 0,
      phoneNumberLength: 0,
      guest_access_allowed: 0,
    };

    localStorage.setItem("currentUser", JSON.stringify(this.temp_user));
    this.coreService.UserSub.next(this.temp_user);

    this.router.navigate(["/dashboard"]);
  }

  closeSelectLocation() {
    this.fulfillment.style.display = "none";
  }

  cancel() {
    this.fulfillment.style.display = "none";
  }

  OpenAddressModel(Address?: null) {
    this.cancel();
    if (Address == null) this.OpenAddress.Openpopup();
    else this.OpenAddress.EditAddress(Address);
  }

  async AlertBox(message) {
    this.ngZone.run(() => {
      this.OpenMessage.Openpopup(message);
    });
  }

  get borderStyle(): string {
    const menuColor =
      this.currentMerchant?.webapp_settings?.menu_color ??
      this.currentMerchant?.menu_color;

    const borderColor =
      this.currentMerchant?.webapp_settings?.menu_border_color ??
      this.currentMerchant?.menu_border_color;

    const borderWidth =
      this.currentMerchant?.webapp_settings?.menu_border_width ??
      this.currentMerchant?.menu_border_width;

    return menuColor !== borderColor
      ? `${borderWidth}px solid ${borderColor}`
      : `${borderWidth}px solid`;
  }

  get menuBorderColor(): string {
    const menuColor =
      this.currentMerchant?.webapp_settings?.menu_font_color_homepgae ??
      this.currentMerchant.menu_font_color_homepgae;

    // const borderColor =
    //   this.currentMerchant.webapp_settings?.menu_border_color ??
    //   this.currentMerchant.menu_border_color;

    return menuColor;
  }
}
